export default __webpack_public_path__ + "static/media/quotes.4d686544.svg";